const checkByteSize = (size) => {
    let maxSize = 5 * 1024 * 1024;
    if (size > maxSize) {
        return true;
    }
}
export default checkByteSize;